//@import dependencies
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//@end

//@import components
import ContentInterestCardComponent from 'app_components/commons/contentInterestCard'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
import IconComponent from 'app_components/commons/icons'
import ContentInterestModuleSkeleton from 'app_components/modules/newsEvents/contentInterest/components/contentInterestModuleSkeleton';
import OfferCardComponent from 'app_components/commons/offercard'
import ResearchCardComponent from 'app_components/commons/researchCard'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
import useWindowWidth from 'app_hooks/useWindowWidth';
// @end

// @INFO Import types
import {IContentInterestModule} from 'app_types/campus/contentInterest/contentInterestTypes'
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../contentInterestModule.scss'
import { customs } from 'app_config/globals';

// @ADD Component types
interface IContentInterestModuleLayoutProps {
  module: IContentInterestModule,
  items: Array<any>
  loading: boolean
}

const CustomArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      {props.icon}
    </div>
  );
}

const ContentInterestModuleLayout: React.FC<IContentInterestModuleLayoutProps> = (props) => {

  const { windowWidth } = useWindowWidth()
  const [colors] = useColors()
  const { t } = useTranslation()

  const getNumberItems = () => {
    if(windowWidth < 576){
      return 1
    }
    if(windowWidth < 991){
      return 2
    }
    return 4
  }

  return(
    <div className='content_interest_list-component'>
      {props.loading ? (
        <ContentInterestModuleSkeleton />
      ) : (
        <>
          {props.items && props.items.length > 0 ? (
            <>
              <Slider
                arrows={true}
                infinite={(props.items?.length >= getNumberItems()) ? true : false}
                slidesToShow={getNumberItems()}
                nextArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleRight' width={24} color={colors.primary} />}/>}
                prevArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleLeft' width={24} color={colors.primary} />}/>}
              >
                {props.items.map((n) => (
                  <Fragment key={`fragment_${n.key}`}>
                    {n.elementType && n.elementType === 'moocs' ? (
                      <>
                      {n.link ? (
                        <div className='item' key={n.key}>
                          <Link to={routingService.getPublicPath(`${n.link}/${n._id}`)}>
                            <OfferCardComponent
                              course={n}
                              list={windowWidth < 991 ? true : false}
                            />
                          </Link>
                        </div>
                      ) : (
                        <div className='item' key={n.key}>
                          <OfferCardComponent
                            course={n}
                            list={windowWidth < 991 ? true : false}
                          />
                        </div>
                      )}
                      </>
                    ) : (
                      <>
                        {props.module.key === 'research' || props.module.key === 'journal' ?
                          <Link
                            to={{pathname: n?.researchUrl}}
                            target='_blank'
                          >
                            {/* <ResearchCardComponent
                              {...n}
                            /> */}
                            <ContentInterestCardComponent
                              {...n}
                              list={windowWidth < 991 ? true : false}
                              share={`${customs.site}`}
                            />
                          </Link>
                        : n.link && props.module.key !== 'webinar' && props.module.key !== 'capsules' && props.module.key !== 'podcast' ? (
                          <div className='item' key={n.key}>
                            <Link to={routingService.getPublicPath(`${n.link}/${n.slug}`)}>
                              <ContentInterestCardComponent
                                {...n}
                                list={windowWidth < 991 ? true : false}
                                share={`${customs.site}`}
                              />
                            </Link>
                          </div>
                        ) : (
                          props.module.key === 'webinar' || props.module.key === 'capsules' || props.module.key === 'podcast' ?
                            <div className='item' key={n.key}>
                              <ContentInterestCardComponent
                                {...n}
                                list={windowWidth < 991 ? true : false}
                                media={{
                                  name: n?.title,
                                  description: n?.description,
                                  type: n?.video?.platform,
                                  url: n?.video?.url
                                }}
                                share={`${customs.site}`}
                              />
                            </div>
                          :
                          <div className='item' key={n.key}>
                            <ContentInterestCardComponent
                              {...n}
                              list={windowWidth < 991 ? true : false}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </Fragment>
                ))}
              </Slider>
              {props.module?.view_more?.link && (
                <div className="content_interest-list-view-more">
                  <Link to={routingService.getPublicPath(props.module?.view_more?.link)}>
                    {t(`modules.content_interest.${props.module.key}.view_more`)}
                  </Link>
                </div>
              )}
            </>
          ) : (
            <div>
              <AlertComponent
                type='warning'
                title={t('modules.content_interest.no_data', {type: props.module.title})}
              />
            </div>
          )}
        </>
      )}

    </div>
  )
}

export default ContentInterestModuleLayout
